import { IAttendance } from "./IGameAttendances";

export interface IGameAttendancesVotes extends IAttendancesVotes {
  GameAttendances: IAttendance | null;
}

export interface IAttendancesVotes {
  created_at: string;
  game_attendance_id: number;
  id: number;
  player_id: number;
  type: string;
}

export enum VoteType {
  CREATIVITY = "creativity",
  DEFENSE = "defense",
  EFFORT = "effort",
}
